import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Icon from "material-ui-next/Icon";
import Tooltip from "material-ui-next/Tooltip";
import Typography from "material-ui-next/Typography";
import {
  CheckBox,
  DescriptionField,
  Loadable,
  If,
  StyledButton
} from "components/support";

import style from "./style";

import PendingTransactions from "./pending-transactions";

class CompanyIntegrationsMyFinanceView extends Component {
  showPendingTransactions = () => {
    const { presenter, company, viewModel } = this.props;
    const { accountName, entityName, pendingTransactionsOpen } = viewModel;
    const { token } = company.integrations.my_finance || {};

    return (
      <PendingTransactions
        pendingTransactionsOpen={pendingTransactionsOpen}
        token={token}
        accountName={accountName}
        entityName={entityName}
        onPendingTransactionsClose={() =>
          presenter.onPendingTransactionsClose()
        }
      />
    );
  };

  render() {
    const { className, company, viewModel, presenter } = this.props;
    const {
      loading,
      accountName,
      entityName,
      pendingTransactionsOpen
    } = viewModel;
    const { enabled, token } = company.integrations.my_finance || {};

    return (
      <div className={`${className} grid-container`}>
        <Loadable loading={loading}>
          <Row>
            <Col xs={12}>
              <div className="grid-container mt-sm mb-sm">
                <Typography type="headline">MyFinance</Typography>

                <hr />

                <Row bottom="xs">
                  <Col xs={12} md={8}>
                    <div className="integration-status">
                      <CheckBox
                        checked={enabled}
                        style={{ paddingLeft: 4 }}
                        label="Status Integração"
                        disabled
                      />
                      <div className="tooltip">
                        <Tooltip
                          key="tooltip-right-myfinance"
                          title="Edite a empresa para ativar ou desativar a integração."
                          placement="right"
                        >
                          <Icon className="tooltip-icon">info</Icon>
                        </Tooltip>
                      </div>
                    </div>
                  </Col>
                  <Col xs={12} md={4}>
                    <StyledButton
                      accent
                      label="Transações não sincronizadas"
                      onClick={() => presenter.onPendingTransactionsOpen()}
                    />
                    <If test={pendingTransactionsOpen}>
                      {this.showPendingTransactions()}
                    </If>
                  </Col>
                </Row>

                <Row bottom="xs">
                  <Col xs={12}>
                    <DescriptionField
                      label="Token do MyFinance"
                      value={token}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col xs={12} md={6}>
                    <DescriptionField
                      label="Conta integrada"
                      value={accountName}
                    />
                  </Col>
                  <Col xs={12} md={6}>
                    <DescriptionField
                      label="Entidade integrada"
                      value={entityName}
                    />
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Loadable>
      </div>
    );
  }
}

export default style(CompanyIntegrationsMyFinanceView);



// WEBPACK FOOTER //
// ./src/components/app/registration/company/view/integrations/my-finance/view.jsx